import _ from "lodash";

export const calculateServiceFeeVAT = (serviceFee, VAT) => _.round(serviceFee * VAT, 5) || 0;

export const SUMMARY_COMMON_MAX_SERVICE_FEE = 2; // in case service fee is higher we show an info message
export const SUMMARY_DEPOT_DISCOUNT_INFO = 'Hier können Sie für das gesamte Depot einen Rabatt hinterlegen. Alternativ können Sie den Rabatt auch auf Produktebene anpassen.';

// get max service fee value
export const getSummaryServiceFeeMax = (banksConfig, data_field_key = 'service_fee_max') => {
  if (banksConfig.service_fee_allowed) {
    return banksConfig[data_field_key];
  }
};

export const getSummaryAvailableOptions = (banksData, option_name) => {
  return (banksData[option_name] || []).map(d => ({id: d, value: d, label: `${d} %`}));
};

export const getSummaryDiscountsOptions = (banksData, data_field_key) => {
  // get available discounts
  const availableOptions = getSummaryAvailableOptions(banksData, data_field_key).filter(bankData => bankData.value != 0);
  return _.isEmpty(availableOptions) ? [] : [{id: 'noneOptionId', value: undefined, label: 'Kein'}, ...availableOptions];
};